/**
 * @author Martin Albarracin
 * @file index.js
 * @description Video Calls frame Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';

// Routes
import routes from './routes';

/**
 * Video Calls frame Container.
 * @return { Node } React Video calls frame container.
 */
const VideoCallsFrameContainer = () => {
  return <AppRoutes routes={routes} />;
};

/**
 * @name VideoCallsFrameContainer.propTypes
 * @type { Object }
 */
VideoCallsFrameContainer.propTypes = {};

/**
 * Default props
 */
VideoCallsFrameContainer.defaultProps = {};

export default VideoCallsFrameContainer;
